import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect } from 'react';

import { animationManager } from '@systems/AnimationManager';
import { glassManager } from '@systems/GlassManager';
import { scrollManager } from '@systems/ScrollManager';
import { themeManager } from '@systems/ThemeManager';

/**
 * Starts every system. Each init() is idempotent.
 *
 * Called twice by design: once from main.tsx before React renders, because
 * the theme, glass mode and GSAP plugins must be in place before the first
 * component mounts; and again from the layout here, because Fast Refresh
 * replaces a system module with a fresh, uninitialised instance and this
 * effect re-runs when that happens. In production the second call is a
 * no-op.
 */
export const initSystems = (): void => {
  glassManager.init();
  themeManager.init();
  animationManager.init();
  scrollManager.init();
};

export const useSystems = (): void => {
  useEffect(() => {
    initSystems();

    /* Web fonts change line lengths, and so every reveal trigger's
       position. Measured once more after they arrive. */
    void document.fonts.ready.then(() => {
      ScrollTrigger.refresh();
    });
  }, []);
};
